import { SchemaElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Schema extends SchemaElement {
  // OpenAPI 3.2 does not introduce new fields to Schema.
  // All schema fields (discriminator, xml, externalDocs, example) already exist in OpenAPI 3.1.
}
export default Schema;